import { useTranslation } from "react-i18next";
import { useNetworkStatus } from "../../hooks/useNetworkStatus";

export function OfflineIndicator() {
  const { t } = useTranslation("common");
  const { isOffline } = useNetworkStatus();

  return (
    <div
      data-testid="offline-indicator"
      className={`fixed right-4 z-40 rounded-full bg-gray-600 px-3 py-1 text-sm text-white transition-opacity duration-300 ${
        isOffline ? "opacity-100" : "pointer-events-none opacity-0"
      }`}
      style={{ bottom: "calc(var(--bottom-nav-height, 0px) + 1rem)" }}
    >
      {t("offline.status")}
    </div>
  );
}
